export default [
  {
    "name":"tags",
    "data": [
    	{
        "name" : "clearance",
        "note" : "This is a clearance item, sizing and stock may be limited",
        "textFont" : "text-danger text-md"
      },
      {
        "name" : "solid wood",
        "note" : "Solid wood tables are subject to shrinkage, warping and seasonal cracks due to natural moisture within. These occurrences are non-structural and will not affect the durability of table. It is the responsibility of the user to maintain a 30%-40% humity level to accommodate solid wood.",
        "textFont" : "text-danger text-md"
      },
      {
        "name" : "formica laminate",
        "note" : "All Formica Laminate comes with Black Vinyl Edge by default",
        "textFont" : "text-danger text-md"
      },
      {
        "name" : "metal laminate",
        "note" : "All Metal Laminate comes with Aluminium Edge by default",
        "textFont" : "text-danger text-md"
      }
    ]
  },
  {
    "name":"size",
    "data": [
      { "name" : "24\"x24\"", "image" : "!icon/!sizing/2424.png"},
      { "name" : "24\"x28\"", "image" : "!icon/!sizing/2428.png"},
      { "name" : "24\"x42\"", "image" : "!icon/!sizing/2442.png"},
      { "name" : "28\"x46\"", "image" : "!icon/!sizing/2846.png"},
      { "name" : "28\"x65\"", "image" : "!icon/!sizing/2865.png"},
      { "name" : "36\"x36\"", "image" : "!icon/!sizing/3636.png"},
      { "name" : "36\"x36\">51\"R", "image" : "!icon/!sizing/3636-51R.png"},
      { "name" : "24\"R", "image" : "!icon/!sizing/24R.png"},
      { "name" : "30\"R", "image" : "!icon/!sizing/30R.png"},
      { "name" : "36\"R", "image" : "!icon/!sizing/36R.png"},
      { "name" : "48\"R", "image" : "!icon/!sizing/48R.png"},
      { "name" : "60\"R", "image" : "!icon/!sizing/60R.png"},
      { "name" : "Custom", "image" : "!icon/!sizing/Custom.png"}
    ]
  },
  {
    "name":"seating",
    "data": [
      { "name" : "Square Red ", "image" : "!icon/!seating/Square_Cushion_R.png"},
      { "name" : "Black", "image" : "!icon/!seating/Round_Cushion_B.png"},
      { "name" : "Burgundy", "image" : "!icon/!seating/Round_Cushion_BU.png"},
      { "name" : "Green", "image" : "!icon/!seating/Round_Cushion_GN.png"},
      { "name" : "Wood Mahogany", "image" : "!icon/!seating/Woodseat_M.png"},
      { "name" : "Wood Natural", "image" : "!icon/!seating/Woodseat_N.png"},
      { "name" : "Wood Cherry", "image" : "!icon/!seating/Woodseat_C.png"},
      { "name" : "Wood Walnut", "image" : "!icon/!seating/Woodseat_W.png"},
      { "name" : "Veneer Wood Mahogany", "image" : "!icon/!seating/VWoodseat_M.png"},
      { "name" : "Veneer Wood Natural", "image" : "!icon/!seating/VWoodseat_N.png"},
      { "name" : "Veneer Wood Walnut", "image" : "!icon/!seating/VWoodseat_W.png"},
    ]
  },
  {
    "name":"edge",
    "data": [
      { "name" : "Black Vinyl", "image" : "!icon/!edge/Black_Vinyl.png"},
      { "name" : "Chrome Plastic", "image" : "!icon/!edge/Chrome_Plastic.png"},
      { "name" : "Aluminium Edge", "image" : "!icon/!edge/Aluminium_Edge.png"},
      { "name" : "Wood Edge", "image" : "!icon/!edge/Wood_Edge.png"},
      { "name" : "Self Edge", "image" : "!icon/!edge/Self_Edge.png"}
    ]
  }

];



// WEBPACK FOOTER //
// ./src/data/attributeNotes.js